export default time => new Promise(resolve => setTimeout(resolve, time));



// WEBPACK FOOTER //
// ./registration/static_source/js/registration/lib/pause.js